var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"install-app"},[(_vm.modalBox.open)?_c('modal-box',{attrs:{"header":"Install App"},on:{"close":_vm.onModalBoxClose}},[_c('button',{staticClass:"btn btn-primary btn-round",on:{"click":_vm.onInstall}},[_vm._v("INSTALL")])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ebd7a82","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/install/InstallApp.vue
// module id = null
// module chunks = 